export class Calculator {
  constructor(){this.clear();}
  clear(){this.display='0';this.value=null;this.operator=null;this.fresh=true;this.repeat=null;}
  input(key){
    if(key==='C'){this.clear();return this.display;}
    if(key==='CE'){this.display='0';this.fresh=true;return this.display;}
    if(/^\d$/.test(key)||key==='.'){
      if(this.fresh||this.display==='Error'){this.display=key==='.'?'0.':key;this.fresh=false;}
      else if(key==='.'&&!this.display.includes('.'))this.display+='.';
      else if(key!=='.'&&this.display.replace('-','').length<14)this.display=this.display==='0'?key:this.display+key;
      return this.display;
    }
    if(key==='⌫'){this.display=this.display.length>1?this.display.slice(0,-1):'0';if(this.display==='-')this.display='0';return this.display;}
    if(key==='±'||key==='%'){this.display=this.format(Number(this.display)*(key==='±'?-1:.01));return this.display;}
    const n=Number(this.display);
    if(!Number.isFinite(n)){this.clear();return this.display;}
    if(['+','−','×','÷'].includes(key)){
      if(this.operator&&!this.fresh)this.display=this.calculate(this.value,n,this.operator);
      this.value=Number(this.display);this.operator=key;this.fresh=true;this.repeat=null;
    }else if(key==='='){
      if(this.operator){this.repeat={operator:this.operator,value:n};this.display=this.calculate(this.value,n,this.operator);}
      else if(this.repeat)this.display=this.calculate(n,this.repeat.value,this.repeat.operator);
      this.operator=null;this.value=null;this.fresh=true;
    }
    return this.display;
  }
  calculate(a,b,op){return this.format(op==='+'?a+b:op==='−'?a-b:op==='×'?a*b:b===0?NaN:a/b);}
  format(n){return Number.isFinite(n)?String(Number(n.toPrecision(12))):'Error';}
}
